<button class="btn" [type]="buttonType" [ngClass]="'btn-' + themeColor + ' ' + buttonClass" [disabled]="buttonDisabled || waiting" (click)="onClickMethod()">{{ shouldTranslated ? (buttonText | translate) : buttonText }}</button>
